import { Row, Col, Typography } from "antd";
const { Text } = Typography;

const PriceDiscountPreview = ({ price, sellingPrice }) => {
  return price > 0 && sellingPrice > 0 ? (
    <Row style={{ width: "100%" }}>
      <Row style={{ width: "100%" }}>
        <Text strong style={{ fontSize: "1.25rem" }}>
          Original ${price}
        </Text>
      </Row>
      <Row style={{ width: "100%" }}>
        <Text strong style={{ fontSize: "1.25rem", color: "var(--ion-color-primary)" }}>
          Sells at ${sellingPrice}
        </Text>
      </Row>
    </Row>
  ) : null;
};

export default PriceDiscountPreview;
